export const documentationRoutes = {
    '/': '/01-inicio.md',
    '/dashboard/default': '/01-inicio.md',
    '/users': '/02-utilizadores.md',
    '/users/add': '/02a-criar-utilizador.md',
    '/users/user/edit': '/02b-editar-utilizador.md',
    '/users/user': '/02c-paciente.md',
    '/users/user/record': '/02d-exercicio-detalhes.md',
    '/grupos': '/05-grupos.md',
    '/grupos/criar': '/05a-criar-grupo.md',
    '/grupos/:groupId': '/05b-detalhes-grupo.md',
    '/meusgrupos': '/05c-meus-grupos.md',
    '/planos': '/03-planos.md',
    '/planos/criar': '/03a-criar-plano.md',
    '/planos/:uuid': '/03b-visualizar-plano.md',
    '/nutricao': '/07-planos-nutricao.md',
    '/nutricao/criar': '/07a-criar-plano-nutricao.md',
    '/nutricao/:uuid': '/07b-visualizar-plano-nutricao.md',
    '/questionarios': '/04-questionarios.md',
    '/questionarios/:uuid': '/04b-visualizar-questionario.md',
    '/aprender': '/06-aprender.md',
    '/aprender/criar': '/06a-criar-conteudo.md',
    '/aprender/:uuid': '/06b-visualizar-conteudo.md'
};
